<template>
  <div class="pt-0">
    <h3 class="text-center">
      <b>Verify your Email Address</b>
    </h3>
    <p class="text-center">
      Please confirm your email address by entering the four digit verification code. You find this
      code in an email sent to the specified email address. In case you have problems finding the
      email, please make sure that you have entered the correct email address and check your spam
      folder.
    </p>

    <Message v-show="infoMessage" class="mt-2" type="info-alert">
      <p slot="alert-message" class="mb-0">
        {{ infoMessage }}
      </p>
    </Message>

    <Message v-show="errorMessage" class="mt-2" type="error-alert">
      <p slot="alert-message" class="mb-0">
        {{ errorMessage }}
      </p>
    </Message>
    <form id="form-ver" @submit.prevent="codeVefirication">
      <div class="form-group d-flex" style="justify-content: space-between">
        <input
          class="form-control"
          @keyup.capture="$refs.text2.focus()"
          @keyup.delete="$refs.text1.focus()"
          v-model.trim.lazy="$v.codes.field1.$model"
          placeholder=" "
          ref="text1"
          type="text"
          maxlength="1"
          size="1"
          min="0"
          max="9"
          pattern="[0-9]{1}"
          required
        />
        <input
          class="form-control"
          @keyup.capture="$refs.text3.focus()"
          @keyup.delete="$refs.text1.focus()"
          v-model.trim.lazy="$v.codes.field2.$model"
          id="field2"
          placeholder=" "
          ref="text2"
          type="text"
          maxlength="1"
          size="1"
          min="0"
          max="9"
          pattern="[0-9]{1}"
          required
        />
        <input
          class="form-control"
          @keyup.capture="$refs.text4.focus()"
          @keyup.delete="$refs.text2.focus()"
          v-model.trim.lazy="$v.codes.field3.$model"
          id="field3"
          placeholder=" "
          ref="text3"
          type="text"
          maxlength="1"
          size="1"
          min="0"
          max="9"
          pattern="[0-9]{1}"
          required
        />
        <input
          class="form-control"
          @keyup.delete="$refs.text3.focus()"
          v-model.trim.lazy="$v.codes.field4.$model"
          id="field4"
          placeholder=" "
          ref="text4"
          type="text"
          maxlength="1"
          size="1"
          min="0"
          max="9"
          pattern="[0-9]{1}"
          required
        />
      </div>

      <!-- <button @click="$emit('prevStep')" class="btn btn-secondary btn-block my-4 mr-5">
          <i class="fa fa-chevron-left mr-2"></i> Previous
        </button> -->
      <button type="submit" class="btn btn-primary btn-block my-4">OK</button>
    </form>

    <!--  <div class="row justify-content-center">
      <div class="col-md-10">
        
      </div>
    </div> -->

    <footer class="text-center mb-5">
      Didn't receive the code?
      <br />
      <router-link to @click="resendVerificationCode" class="mr-1">
        <span>Send code again to {{ currentEmail }}</span>
      </router-link>
      <router-link to>
        <span @click="$emit('prevStep')">(change email address)</span>
      </router-link>
    </footer>
    <Spinner :isLoading="isLoading" />
  </div>
</template>

<script>
import Message from '@/components/AlertMessages/Message';
import { errorService } from '../../services/errorService';
import Spinner from '../common/LoadingSpinner/Spinner';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';

export default {
  components: { Message, Spinner },
  props: {
    currentEmail: String,
  },
  data() {
    return {
      isLoading: false,
      errorMessage: '',
      infoMessage: '',
      codes: { field1: '', field2: '', field3: '', field4: '' },
    };
  },
  validations: {
    codes: {
      field1: {
        required,
        maxLength: maxLength(1),
        minLength: minLength(2),
      },
      field2: {
        required,
        maxLength: maxLength(1),
        minLength: minLength(1),
      },
      field3: {
        required,
        maxLength: maxLength(1),
        minLength: minLength(1),
      },
      field4: {
        required,
        maxLength: maxLength(1),
        minLength: minLength(1),
      },
    },
  },
  methods: {
    codeVefirication() {
      this.isLoading = true;
      let code = [];

      Object.values(this.codes).forEach(val => {
        code.push(val);
      });

      code = code.join('');

      localStorage.setItem('code', code);

      this.$store
        .dispatch('confirmCode', {
          uuid: localStorage.getItem('uuid'),
          code: localStorage.getItem('code'),
        })
        .then(response => {
          this.isRegister = false;
          const { user_type } = response.data;

          localStorage.setItem('acc', user_type);

          this.$toasted.success('You are successfully logged in.', {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .then(() => {
          this.$router.push({ name: 'user-profile' });
        })
        .catch(err => {
          this.isLoading = false;
          this.isRegister = false;
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    resendVerificationCode() {
      setTimeout(() => {
        this.infoMessage = 'We have sent you another code. Please check your email. ';
      }, 2000);
    },
  },
  watch: {
    user: {
      handler() {
        this.errorMessage = '';
        this.infoMessage = '';
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.card {
  background-color: rgba(238, 238, 238, 0.28);
}

h3 {
  margin: 0 0 10px;
  padding: 0;
  line-height: 1.25;
}

/* span {
  font-size: 90%;
} */

#form-ver {
  max-width: 300px;
  margin: 25px auto 0;

  .form-control {
    text-align: center;
    color: #505050;
    font-size: 50px;
    border: solid 2px #eaeaea;
    box-shadow: 0 0 3px rgba(204, 204, 204, 0.555) inset;
    /*  outline: none; */
    width: 60px !important;
    height: 90px;

    border-radius: 6px 6px;
    border-width: 2px;

    &:hover {
      border: solid 2px rgb(223, 223, 223);
      transition: all 0.2s ease-in-out;
    }

    &:focus {
      border: 2px solid $color-base-blue;
    }

    &:not(:placeholder-shown) {
      -webkit-box-shadow: 0px 10px 23px -15px rgba(0, 0, 0, 0.25);
      box-shadow: 0px 10px 23px -15px rgba(0, 0, 0, 0.25);
    }

    &::selection {
      background: transparent;
    }
  }
  button {
    width: 200px;
    margin: 0 auto;
  }
}

/* Chrome, Safari, Edge, Opera */
/* input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
} */

/* Firefox */
/* input[type='number'] {
  -moz-appearance: textfield;
} */
</style>
